import React, { useCallback, useMemo, useState } from "react";
import { Route, Redirect, Switch, useHistory } from "react-router-dom";
import client from "@culturehq/client";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";

import EnhancedEvent from "components/events/Event";

import CreatePhotos from "components/event/CreatePhotos";
import EventView from "components/event/EventView";
import EventSurvey from "components/event/EventSurvey";
import EventExpenses from "components/event/Expenses";
import { UpdateEventSideBar } from "components/common/EventSidebar";
import EventUpdate from "components/events/EventUpdate";

const Event = ({ match }) => {
  const { profile } = useProfile();
  const history = useHistory();
  const [updatedEvent, setUpdatedEvent] = useState(undefined);
  const { location: { pathname } } = history;

  const { error, fetching, json, onUpdate } = useFetch(
    () => client.getEvent({ eventId: match.params.eventId }),
    [match.params.eventId]
  );

  const handleEventUpdate = useCallback(
    updates => onUpdate(({ event }) => ({ event: { ...event, ...updates } })),
    [onUpdate]
  );

  const handleRefreshInvitations = async () => {
    const { event } = await client.getEvent({ eventId: match.params.eventId });
    setUpdatedEvent(event);
  };

  const event = useMemo(() => {
    if (updatedEvent) {
      return new EnhancedEvent(updatedEvent);
    }

    return new EnhancedEvent(json.event || {});
  },
  [json, updatedEvent]);

  if (error) {
    return <Redirect to="/404" push />;
  }

  if (fetching) {
    return null;
  }

  return (
    <div className="event_create event_view Events">
      {event.isUserHostOrAdmin(profile) && (
        <UpdateEventSideBar event={event} profile={profile} onEventUpdate={handleEventUpdate} />
      )}
      <div className="work_area">
        <div className="Event floatm-l">
          <Switch>
            <Route
              exact
              path="/events/:eventsId/edit/:eventForm"
              render={() => <EventUpdate event={event} onEventUpdate={handleEventUpdate} />}
            />
            <Route
              exact
              path="/events/:eventId/photos/create"
              render={() => <CreatePhotos event={event} />}
            />
            <Route
              exact
              path="/events/:eventId/photos"
              render={() => (
                <EventView
                  event={event}
                  onEventUpdate={handleEventUpdate}
                  onRefreshInvitations={handleRefreshInvitations}
                />
              )}
            />
            <Route
              exact
              path="/events/:eventId/survey"
              render={() => <EventSurvey event={event} onEventUpdate={handleEventUpdate} />}
            />
            <Route
              exact
              path="/events/:eventId/expenses"
              render={() => <EventExpenses event={event} />}
            />
            <Route
              exact
              path="/events/:eventId"
              render={() => (
                <EventView
                  event={event}
                  onEventUpdate={handleEventUpdate}
                  onRefreshInvitations={handleRefreshInvitations}
                />
              )}
            />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Event;
